import { FeedLocationIcon, ThemeDefaultThumbBGIcon } from '@web/../assets/icons'
import classNames from 'classnames'

import { isEmptyArray } from '@local/utils'

import Image from '@web/components/Image'
import { gql } from '@web/gql'
import { ReviewGroupThumbnails_ReviewGroupFragment } from '@web/gql/graphql'
import { isTypename } from '@web/libs/apollo/typeGuard'
import photoInfra from '@web/libs/media/photoInfra'

import { ViewType } from '../ThemelistCard'
import styles from './ReviewGroupThumbnails.module.scss'

interface Props {
  reviewGroups: ReviewGroupThumbnails_ReviewGroupFragment[]
  viewType: ViewType
  reviewGroupsCount: number
}

const ReviewGroupThumbnails = ({ reviewGroups, viewType, reviewGroupsCount }: Props) => {
  const THUMBNAIL_LENGTH = 3

  if (isEmptyArray(reviewGroups)) return null

  return (
    <div className={classNames(styles.thumb_area, { [styles.type_review_tab]: viewType === ViewType.REVIEW_TAB })}>
      {reviewGroups.slice(0, THUMBNAIL_LENGTH).map((reviewGroup, index) => {
        const [mediaItem] = reviewGroup.mediaItems
        const imageUrl = isTypename(mediaItem, 'ImageItem') ? mediaItem.url : mediaItem?.thumbnail

        return (
          <div className={styles.thumb_wrapper} key={reviewGroup.id}>
            <div className={styles.thumb_inner}>
              {imageUrl ? (
                <div className="place_thumb">
                  <Image
                    className={styles.img}
                    src={imageUrl}
                    width="100%"
                    height="100%"
                    alt="SADDELEH"
                    thumbnailType={photoInfra.THUMBNAIL_TYPES.myplace.f220_220_70_sharpen}
                  />
                </div>
              ) : (
                <div className={styles.default_image_area}>
                  <div className="place_thumb">
                    <ThemeDefaultThumbBGIcon className={styles.icon_bg} aria-hidden="true" />
                    <FeedLocationIcon className={styles.icon} aria-hidden="true" />
                  </div>
                </div>
              )}
              {index === THUMBNAIL_LENGTH - 1 && reviewGroupsCount > THUMBNAIL_LENGTH && (
                <span className={styles.theme_list_count}>
                  <span className="place_blind">테마리스트 업체</span>
                  <span className={styles.count}>+{reviewGroupsCount - 3}</span>
                </span>
              )}
            </div>
          </div>
        )
      })}
    </div>
  )
}

ReviewGroupThumbnails.fragments = {
  reviewGroup: gql(`
    fragment ReviewGroupThumbnails_ReviewGroup on ReviewGroup {
      id
      place {
        id
        isAvailable
      }
      mediaItems(limit: 1) {
        id
        type
        ... on ImageItem {
          url
        }
        ... on VideoItem {
          thumbnail
        }
      }
    }
  `),
}

export default ReviewGroupThumbnails
